import { CanvasPreview } from './components/CanvasPreview';
import { AnimationControls } from './components/AnimationControls';
import { PresetLibrary } from './components/PresetLibrary';
import { ExportPanel } from './components/ExportPanel';
import { ElementPicker } from './components/ElementPicker';
import { useAnimationStore } from './stores/animationStore';
import { createNewPreset } from './stores/animationStore';

function App() {
  const { currentPreset, savePreset, addPreset } = useAnimationStore();

  const handleSavePreset = () => {
    if (currentPreset) {
      addPreset(currentPreset);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f0f0f',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <header style={{
        padding: '16px 24px',
        borderBottom: '1px solid #222',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <svg width="32" height="32" viewBox="0 0 64 64">
            <defs>
              <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3498db"/>
                <stop offset="100%" stopColor="#9b59b6"/>
              </linearGradient>
            </defs>
            <rect width="64" height="64" rx="12" fill="url(#logoGrad)"/>
            <text x="32" y="44" fontFamily="Arial, sans-serif" fontSize="36" fontWeight="bold" fill="white" textAnchor="middle">A</text>
            <circle cx="48" cy="16" r="4" fill="white" opacity="0.8"/>
            <circle cx="16" cy="48" r="3" fill="white" opacity="0.6"/>
            <circle cx="52" cy="48" r="3" fill="white" opacity="0.7"/>
          </svg>
          <h1 style={{ fontSize: 20, fontWeight: 600 }}>
            Animation Constructor
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <ElementPicker />
          <button
            onClick={() => useAnimationStore.setState(state => ({
              currentPreset: createNewPreset('Новый пресет', 'backgrounds', 'snow')
            }))}
            style={{
              background: '#3498db',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer'
            }}
          >
            + Новый
          </button>
          {currentPreset && (
            <button
              onClick={handleSavePreset}
              style={{
                background: '#27ae60',
                border: 'none',
                borderRadius: 6,
                padding: '8px 16px',
                color: '#fff',
                fontSize: 14,
                cursor: 'pointer'
              }}
            >
              Сохранить
            </button>
          )}
        </div>
      </header>

      <main style={{
        flex: 1,
        display: 'flex',
        padding: 24,
        gap: 24
      }}>
        <div style={{
          width: 280,
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}>
          <PresetLibrary />
          {currentPreset && <ExportPanel />}
        </div>

        <CanvasPreview />

        <AnimationControls />
      </main>
    </div>
  );
}

export default App;